import { combineReducers } from 'redux';
import plan from './plan';
import auth from './auth';
import organization from './organization';

export const rootReducer = combineReducers({
	auth,
	plan,
	organization
});

export type RootState = ReturnType<typeof rootReducer>;
